"use strict";
/* tslint:disable: variable-name no-shadowed-variable */
/// <param name="T">[K]</param>
/// <param name="p_ws">[Pa]</param>
/// <returns>[1/Pa]</returns>
Object.defineProperty(exports, "__esModule", { value: true });
function Get_Henrys_Law_Constant_of_Air(T, p_ws) {
    //if (T < 273.15)
    //  return 0.0;
    var T_c = 647.096;
    var T_r = T / T_c;
    var tau = 1 - T_r;
    var beta_N2 = p_ws *
        Math.exp(-9.67578 / T_r + 4.72162 * Math.pow(tau, 0.355) / T_r +
            11.70585 * Math.pow(T_r, -0.41) * Math.exp(tau));
    var beta_O2 = p_ws *
        Math.exp(-9.44833 / T_r + 4.43822 * Math.pow(tau, 0.355) / T_r +
            11.42005 * Math.pow(T_r, -0.41) * Math.exp(tau));
    var beta_Ar = p_ws *
        Math.exp(-8.40954 / T_r + 4.29587 * Math.pow(tau, 0.355) / T_r +
            10.52779 * Math.pow(T_r, -0.41) * Math.exp(tau));
    var beta_a = 1.0 / (0.7812 / beta_N2 + 0.2095 / beta_O2 + 0.0093 / beta_Ar);
    return 1.0 / (1.01325 * beta_a);
}
exports.Get_Henrys_Law_Constant_of_Air = Get_Henrys_Law_Constant_of_Air;
